const en = {
    language_label: 'Language',
    language_english: 'English',
    language_french: 'Francais',
    language_arabic: 'Arabic',
    nav_dashboard: 'Dashboard',
    nav_club: 'Club',
    nav_leaderboard: 'Leaderboard',
    nav_members: 'Members',
    nav_queue_courts: 'Queue & Courts',
    nav_evaluations: 'Evaluations',
    nav_equipment: 'Equipment',
    nav_match_history: 'Match History',
    nav_daily_report: 'Daily Match Report',
    nav_profile: 'Profile',
    nav_theme_app: 'Theme & App',
    ui_select_club: 'Select club',
    ui_logout: 'Logout',
    role_admin: 'Admin',
    role_coach: 'Coach',
    role_player: 'Player',
    footer_developed_by: 'Developed by',
    footer_rights: 'All rights reserved (c) 2026.',
    brand_logo_alt: 'AIV Logo',
    login_welcome_back: 'Welcome back',
    login_subtitle: 'Enter your credentials to access your account',
    login_brand_subtitle: 'Badminton Club',
    login_email: 'Email',
    login_password: 'Password',
    login_sign_in: 'Sign in',
    login_signing_in: 'Signing in...',
    login_forgot_password: 'Forgot password?',
    login_no_account: "Don't have an account?",
    login_create_account: 'Create account',
    login_create_one_here: 'Create one here',
    login_choose_continue: 'Choose how to continue',
    login_admin_account: 'Admin account',
    login_member_account: 'Member account',
    login_verify_sign_in: 'Verify and Sign In',
    login_verifying_otp: 'Verifying OTP...',
    login_resend_otp: 'Resend OTP',
    signup_title: 'Create your account',
    signup_subtitle: 'Set up your club and start managing members',
    signup_first_name: 'First name',
    signup_last_name: 'Last name',
    signup_email: 'Email',
    signup_password: 'Password',
    signup_confirm_password: 'Confirm password',
    signup_have_account: 'Already have an account?',
    signup_sign_in: 'Sign in',
    signup_register_club: 'Register your club',
    signup_email_verification: 'Email verification',
    signup_choose_package: 'Choose your package',
    signup_create_admin_account: 'Create your club admin account to get started',
    signup_enter_otp_email: 'Enter the OTP sent to your email',
    signup_pick_plan: 'Pick the plan that fits your club best',
    signup_step_account: 'Account',
    signup_step_verify: 'Verify',
    signup_step_package: 'Package',
    signup_club_details: 'Club details',
    signup_required_fields_note: 'Fields marked with * are required.',
    signup_club_name: 'Your Club Name *',
    signup_club_name_placeholder: 'Downtown Racquet Club',
    signup_sport_question: 'Which sport does your club play? *',
    signup_select_sport: 'Select sport',
    signup_admin_details: 'Admin details',
    signup_verify_email: 'Verify email',
    signup_otp_code: 'OTP Code',
    signup_otp_verified: 'OTP verified',
    signup_resend_code: 'Resend code',
    signup_resend_in: 'Resend in',
    signup_change_email: 'Change email',
    signup_continue: 'Continue',
    signup_first_last_required: 'First name and last name are required',
    signup_club_required: 'Club name is required',
    signup_select_sport_required: 'Please select a sport type',
    signup_email_required: 'Email is required',
    signup_passwords_mismatch: 'Passwords do not match',
    signup_password_requirements: 'Password must meet all password requirements',
    signup_accept_required: 'Please agree to the privacy policy and terms and conditions to continue',
    signup_otp_sent: 'OTP sent to your email',
    signup_otp_send_failed: 'Could not send OTP',
    signup_otp_session_missing: 'OTP session missing. Please resend OTP.',
    signup_enter_otp: 'Enter the OTP',
    signup_otp_verification_failed: 'OTP verification failed',
    signup_email_verified_continue: 'Email verified. Click Continue to proceed.',
    signup_verify_email_first: 'Please verify your email first',
    signup_account_created_login: 'Account created. Please log in to continue.',
    signup_failed: 'Signup failed',
    signup_creating_account: 'Creating account...',
    signup_create_account: 'Create account',
    forgot_title: 'Reset your password',
    forgot_subtitle: 'We will email you a secure reset link.',
    forgot_heading: 'Forgot password',
    forgot_description: 'Enter the email associated with your account.',
    forgot_check_inbox: 'Check your inbox',
    forgot_send_link: 'Send reset link',
    forgot_sending_link: 'Sending link...',
    forgot_resend_in: 'Resend in',
    forgot_back_login: 'Back to login',
    forgot_need_help: 'Need help? Contact your club admin.',
    forgot_enter_email_reset: 'Enter your email to receive a reset link',
    forgot_reset_link_sent: 'If the email exists, a reset link has been sent',
    forgot_reset_link_failed: 'Could not send reset link',
    first_login_setup_subtitle: 'Set up your password to get started',
    first_login_title: 'Create Your Password',
    first_login_desc: 'Choose a secure password',
    first_login_new_password: 'New Password',
    first_login_confirm_password: 'Confirm Password',
    first_login_set_continue: 'Set Password & Continue',
    first_login_setting_password: 'Setting password...',
    first_login_invalid_token: 'Invalid or missing token. Please contact your administrator.',
    first_login_go_login: 'Go to Login',
    first_login_agree_privacy: 'I agree to the',
    first_login_agree_terms: 'I agree to the',
    select_club_title: 'Select a Club',
    select_club_subtitle: 'Choose which club to manage or play in',
    select_club_loading: 'Loading clubs...',
    select_club_failed: 'Failed to load clubs',
    select_club_entering: 'Entering club...',
    select_club_none: 'You are not a member of any clubs yet.',
    select_club_no_slogan: 'No slogan set',
    select_club_enter: 'Enter',
    privacy_notice: 'Ontario Privacy Notice',
    privacy_title: 'Privacy Policy',
    terms_notice: 'Legal Terms',
    terms_title: 'Terms and Conditions',
    policy_content: 'Policy Content',
    policy_loading_privacy: 'Loading privacy policy...',
    policy_loading_terms: 'Loading terms and conditions...',
    policy_load_failed: 'Failed to load policy',
    policy_effective_date: 'Effective date',
    policy_version: 'Version',
    policy_read_terms: 'Read our terms and conditions',
    policy_view_privacy: 'View the privacy policy',
    common_go_back: 'Go back',
    common_back: 'Back',
    common_loading: 'Loading...',
    common_error_occurred: 'An error occurred',
    common_save: 'Save',
    common_save_apply: 'Save & Apply',
    auth_account_setup_required: 'Account setup required',
    auth_password_reset_required: 'Password reset required',
    auth_first_time_link_sent: 'We sent a first-time setup link to',
    auth_finish_setup_before_signin: 'Open that email and finish setting your password before signing in.',
    auth_password_expired_use_reset: 'Your password has expired. Use the reset link sent to',
    auth_password_expired_suffix: 'to set a new password.',
    auth_request_new_reset_link: 'Request new reset link',
    auth_2fa_enabled: 'Two-factor authentication is enabled for this account.',
    auth_enter_otp_sent_to: 'Enter the OTP sent to',
    auth_otp_code: 'OTP Code',
    auth_enter_code: 'Enter code',
    auth_2fa_session_expired: '2FA session expired. Please sign in again.',
    auth_enter_otp_prompt: 'Enter the OTP sent to your email',
    auth_otp_failed: 'OTP verification failed',
    auth_select_account_continue: 'Select which account to continue with',
    auth_no_usable_accounts: 'No usable accounts found',
    auth_first_login_check_email: 'Check your email for your first-time setup link to set your password.',
    auth_reset_required_info: 'Your password expired. Request a reset link to continue.',
    auth_enter_otp_to_complete: 'Enter the OTP sent to your email to complete login.',
    auth_welcome_back_toast: 'Welcome back!',
    auth_logged_out_inactivity: 'You were logged out due to inactivity.',
    auth_login_failed: 'Login failed',
    auth_resend_otp_failed: 'Unable to resend OTP',
    auth_otp_resent: 'OTP resent to your email.',
    auth_not_in_club_yet: 'You are not in a club yet. Ask your admin to invite you.',
    auth_continue_account_failed: 'Could not continue with that account',
    auth_session_expired_signin_again: 'Session expired. Please sign in again.',
    auth_session_refresh_failed: 'Session refresh failed. Please sign in again.',
    auth_consent_saved: 'Thanks. Consent recorded.',
    auth_consent_save_failed: 'Could not save your consent',
    auth_accept_both_policies: 'Please accept both policies to continue',
    consent_before_continue: 'Before you continue',
    consent_review_accept_both: 'Please review and accept both policies to access the app.',
    consent_accept_continue: 'Accept and continue',
    consent_saving: 'Saving...',
    first_login_expired_link: 'This first-time login link has expired. Please contact your club admin to request a new invite.',
    first_login_invalid_token_generic: 'Invalid token. Please contact your administrator.',
    first_login_password_mismatch: 'Passwords do not match',
    first_login_password_requirements: 'Password must meet all password requirements',
    first_login_accept_required: 'Please agree to the privacy policy and terms and conditions to continue',
    first_login_password_set_success: 'Password set successfully! Please log in.',
    first_login_password_set_failed: 'Failed to set password',
    first_login_at_least_8: 'At least 8 characters',
    first_login_at_least_1_upper: 'At least one uppercase letter',
    first_login_at_least_1_lower: 'At least one lowercase letter',
    first_login_at_least_1_number: 'At least one number',
    first_login_at_least_1_special: 'At least one special character',
    select_club_failed_load: 'Failed to load clubs',
    settings_title: 'Settings',
    settings_manage_subtitle: 'Manage application settings',
    settings_theme_app_title: 'Theme & App Settings',
    settings_theme_app_desc: 'Customize menu appearance, theme mode, font and language',
    settings_theme_mode: 'Theme Mode',
    settings_light: 'Light',
    settings_dark: 'Dark',
    settings_menu_bg: 'Menu Background Color',
    settings_menu_font: 'Menu Font',
    settings_app_font: 'App Font',
    settings_saved: 'Theme settings applied for this club.',
    settings_save_failed: 'Failed to save club theme settings',
    settings_export_success: 'Data exported successfully!',
    settings_export_failed: 'Failed to export data',
    package_label_elite: 'Elite (Package 3)',
    package_label_pro: 'Pro (Package 2)',
    package_label_starter: 'Starter (Package 1)',
    pkg_name_starter: 'Starter',
    pkg_name_pro: 'Pro',
    pkg_name_elite: 'Elite',
    pkg_tier_1: 'Package 1',
    pkg_tier_2: 'Package 2',
    pkg_tier_3: 'Package 3',
    pkg_feature_everything_pro: 'Everything in Pro',
    pkg_feature_everything_starter: 'Everything in Starter',
    pkg_feature_250_members: 'Up to 250 active members',
    pkg_feature_150_members: 'Up to 150 active members',
    pkg_feature_50_members: 'Up to 50 active members',
    pkg_feature_multi_admin: 'Advanced roles and permissions (multiple club admins)',
    pkg_feature_ui_branding: 'Advanced UI controls (colors/fonts for club branding)',
    pkg_feature_logo: 'Club logo upload/management',
    pkg_feature_avatar: 'Member profile avatar selection',
    pkg_feature_ai_chat: 'AI chat for match-history insights',
    pkg_feature_dashboard_insights: 'Actionable performance insights on dashboard',
    pkg_feature_coach_eval: 'Coach evaluations',
    pkg_feature_equipment: 'Equipment tracking',
    pkg_feature_ml_limited: 'Limited ML-assisted analytics for key performance trends',
    pkg_feature_daily_advanced: 'Daily match reports and advanced leaderboard trends',
    pkg_feature_member_mgmt: 'Member management',
    pkg_feature_queue_courts: 'Queue and court assignment',
    pkg_feature_basic_leaderboard: 'Match history and basic leaderboard',
    pkg_feature_basic_dashboard: 'Basic admin dashboard',
    pkg_gate_upgrade_plan: 'Upgrade your plan',
    pkg_gate_unlock: 'Unlock',
    pkg_gate_unavailable: "This feature isn't available in your current plan.",
    pkg_gate_current_plan: 'Your Current Plan',
    pkg_gate_upgrade_button: 'Upgrade Package',
    pkg_gate_elite_only: 'This feature is available on Elite (Package 3) only.',
    pkg_gate_available_on: 'This feature is available on Pro (Package 2) and Elite (Package 3).',
    pkg_gate_contact_admin: 'Please contact your club admin to upgrade the package and unlock this feature.',
    pkg_page_title: 'Packages',
    pkg_page_subtitle: "Compare all plans and see your club's active package.",
    pkg_current: 'Current',
    pkg_current_plan: 'Current Plan',
    pkg_manage_subscription: 'Manage Subscription',
    pkg_contact_admin: 'Contact Admin',
    pkg_month: 'month',
    pkg_year: 'year',
    pkg_yearly_savings: 'yearly savings',
    pkg_manage_current_plan: 'Manage Current Plan',
    pkg_upgrade_to_this: 'Upgrade to This Plan',
    pkg_contact_admin_changes: 'Contact your club admin for plan changes.',
    pkg_need_billing_controls: 'Need billing controls? Open',
    pkg_billing_admin_only: 'Billing controls are available to club admins only.',
    pkg_upgrade_request_subject: 'Package Upgrade Request',
    insights_generate_weekly: 'Generate weekly insight',
    insights_already_generated_week: 'Already generated this week',
    profile_enable_2fa_login_otp_every_time: 'Enable 2FA for login (email OTP will be required every time).',
    profile_evaluations_unavailable_starter: 'Evaluations are unavailable on Starter (Package 1)',
    profile_upgrade_pro_elite_evaluations: 'Upgrade to Pro or Elite to view evaluation history and category scores.',
    profile_change_package_from_club_settings: 'You can change the package from Club settings.',
    members_capacity_updated: 'Active members updated to match your package limit.',
    members_capacity_exceed_intro: 'Active members exceed your package limit. Keep up to',
    members_capacity_active_members_for: 'active members for',
    members_select_active_title: 'Select Active Members',
    members_select_active_desc: 'Your current package allows up to {{limit}} active members. Select who should stay active.',
    members_capacity_selected: 'Selected',
    members_capacity_current_active: 'Current active',
    members_applying: 'Applying...',
    members_apply_selection: 'Apply Selection',
    common_close: 'Close',
    leaderboard_empty_no_matches: 'No completed matches yet to build the leaderboard.',
    leaderboard_empty_search: 'No players match your search.',
    leaderboard_insights_title: 'Leaderboard Insights',
    leaderboard_insights_availability: 'Advanced leaderboard insights are available on Pro (Package 2) and Elite (Package 3).',
    leaderboard_insights_contact_admin: 'Please contact your club admin to upgrade the package and unlock these leaderboard insights.',
    leaderboard_select_club: 'Select a club to view the leaderboard.',
    leaderboard_search_placeholder: 'Search by player name',
    leaderboard_subtitle: 'Rankings are based on rating (evaluation + match performance).',
    leaderboard_rating: 'Rating',
    leaderboard_games: 'Games',
    leaderboard_won: 'Won',
    leaderboard_lost: 'Lost',
    leaderboard_points_earned: 'Points Earned',
    member_status_active: 'Active',
    member_status_inactive: 'Inactive',
    member_activated: 'Member activated',
    member_deactivated: 'Member deactivated',
    evaluation_delete_confirm: 'Delete this evaluation? This cannot be undone.',
    equipment_delete_confirm: 'Are you sure you want to delete this equipment?',
    delete_evaluation_failed: 'Failed to delete evaluation',
    delete_equipment_failed: 'Failed to delete equipment',
    member_remove_confirm: 'Are you sure you want to remove {name}?',
    weekly_insights_count: '{count} insights in this week',
    insight_weekly_ready: 'Your weekly insight is ready.',
    insight_unable_generate: 'Unable to generate an insight right now.',
    insight_already_generated_week: 'Already generated this week',
    insight_generate_weekly: 'Generate weekly insight',
    club_no_active_selected: 'No active club selected',
    club_updated_simple: 'Club updated',
    club_update_failed: 'Could not update club',
    superadmin_failed_load_billing_snapshot: 'Failed to load billing snapshot',
    superadmin_failed_load_policies: 'Failed to load policies',
    superadmin_failed_load_failed_payments: 'Failed to load failed payments',
    superadmin_policy_title_required: 'Policy title is required',
    superadmin_draft_saved: 'Draft saved',
    superadmin_could_not_save_draft: 'Could not save draft',
    superadmin_version_required: 'Version is required',
    superadmin_policy_published: 'Policy published',
    superadmin_could_not_publish_policy: 'Could not publish policy',
    leaderboard_points_lost: 'Points Lost',
    leaderboard_pd: 'Point Difference (PD)',
    leaderboard_rank: 'Rank',
    leaderboard_player: 'Player',
    leaderboard_points: 'Points',
    leaderboard_scored: 'Scored',
    leaderboard_against: 'Against',
    leaderboard_you: 'You',
    leaderboard_reevaluate: 'Re-evaluate',
    leaderboard_showing: 'Showing',
    leaderboard_of: 'of',
    leaderboard_rating_improved: 'Rating improved',
    leaderboard_rating_decreased: 'Rating decreased',
    dashboard_eval_analytics: 'Evaluation Analytics',
    dashboard_rank_analytics: 'Ranking Analytics',
    dashboard_profile_analytics: 'Profile Analytics',
    dashboard_visual_unavailable: 'Visual unavailable',
    dashboard_locked_in_starter: 'Locked in Starter',
    dashboard_current_plan: 'Current Plan',
    dashboard_available_in_pro_elite: 'Available in Pro and Elite',
    dashboard_eval_progress: 'Evaluation Progress Over Time',
    dashboard_eval_hint: 'Track rating trends as fresh evaluations are added.',
    dashboard_eval_progress_tooltip: 'Average line shows overall evaluation rating trend. Toggle categories to focus on strengths or gaps.',
    dashboard_average: 'Average',
    dashboard_technical: 'Technical',
    dashboard_movement: 'Movement',
    dashboard_tactical: 'Tactical',
    dashboard_physical: 'Physical',
    dashboard_psychological: 'Psychological',
    dashboard_waiting_for_evaluations: 'Waiting for evaluations.',
    dashboard_club_matches: 'Club Matches',
    dashboard_completed_matches_selected_club: 'Completed matches in selected club',
    dashboard_avg_matches_per_court_day: 'Avg Matches per Court / Day',
    dashboard_avg_active_courts_day: 'Avg Active Courts / Day',
    dashboard_completed_matches_divided_by_courts: 'Completed matches divided by courts across active match days',
    dashboard_avg_queue_wait_min: 'Avg Queue Wait (min)',
    dashboard_from_club_queue_sessions: 'From club queue sessions',
    dashboard_avg_match_duration: 'Avg Match Duration',
    dashboard_average_duration_completed_club_matches: 'Average duration of completed club matches',
    dashboard_my_matches_today: 'My Matches Today',
    dashboard_queue_status: 'Queue Status',
    dashboard_total_members: 'Total Members',
    dashboard_no_active_matches_now: 'No active matches right now.',
    dashboard_matches_played_today: 'Matches Played Today',
    dashboard_wins_losses_by_day: 'Wins & Losses by Day',
    dashboard_wins_losses_tooltip: 'Shows your daily match results for the selected range.',
    dashboard_points_scored_vs_lost_day: 'Points Scored vs Points Lost by Day',
    dashboard_points_chart_tooltip: 'Daily points scored and conceded for the selected range.',
    dashboard_no_completed_matches_chart: 'No completed matches to chart yet.',
    dashboard_no_leaderboard_history: 'No leaderboard history yet.',
    dashboard_not_enough_match_data_pie: 'Not enough match data for pie chart.',
    dashboard_evaluation_data_unavailable: 'Evaluation data is not available yet.',
    dashboard_queue_history_unavailable: 'Queue history is not available yet.',
    dashboard_no_completed_matches_heatmap: 'No completed matches to build a heatmap.',
    dashboard_7d_avg: '7d Avg',
    dashboard_rank_last_days: 'Leaderboard Rank (Last {{days}} Days)',
    dashboard_rank_tooltip: 'Your leaderboard position based on evaluations and match results over the selected period.',
    dashboard_rank_30d: 'Leaderboard Rank (30 Days)',
    dashboard_rank_hint: 'See how your ranking moves over time once matches are recorded.',
    dashboard_club_matches_by_selection_mode: 'Club Matches by Selection Mode (Last {{days}} Days)',
    dashboard_selection_mode_tooltip: 'Share of matches by selection mechanism for the same period as the stacked chart.',
    dashboard_my_evaluation_profile: 'My Evaluation Profile',
    dashboard_evaluation_profile_tooltip: 'Shows your average score by evaluation category.',
    dashboard_profile_hint: 'View your category-wise skill profile and identify strengths and improvement areas.',
    dashboard_queue_wait_distribution: 'Queue Wait Time Distribution',
    dashboard_queue_distribution_tooltip: 'Distribution of queue session durations grouped into wait-time buckets.',
    dashboard_queue_sessions: 'Queue Sessions',
    dashboard_court_usage_day_of_week: 'Court Usage by Day of Week',
    dashboard_court_usage_tooltip: 'Each cell shows how many completed matches were played on a court for a day of week.',
    dashboard_court: 'Court',
    dashboard_court_number: 'Court {{court}}',
    dashboard_court_match_count_title: 'Court {{court}} {{day}}: {{count}} {{matchWord}}',
    dashboard_match_singular: 'match',
    dashboard_match_plural: 'matches',
    dashboard_price_label: 'Price',
    queue_need_more_players: 'Need {{count}} more players in queue',
    common_prev: 'Prev',
    common_next: 'Next',
    common_page: 'Page',
    landing_nav_features: 'Features',
    landing_nav_showcase: 'Showcase',
    landing_nav_pricing: 'Pricing',
    landing_nav_contact: 'Contact',
    landing_brand_subtitle: 'Racket Sports Intelligence',
    landing_login: 'Login',
    landing_start_free: 'Start Free',
    landing_hero_member_eyebrow: 'Member Management',
    landing_hero_member_title: 'Bring every player, coach, and admin into one organized club system.',
    landing_hero_member_desc: 'Handle onboarding, bulk imports, access control, and first-time login setup from a member workflow designed for modern racket sports clubs.',
    landing_hero_create_club: 'Create your club',
    landing_hero_see_pricing: 'See pricing',
    landing_hero_stats_eyebrow: 'Stats & Leaderboard',
    landing_hero_stats_title: 'Turn daily club activity into reports, rankings, and usable performance insight.',
    landing_hero_stats_desc: 'Track leaderboard movement, match history, evaluations, daily reporting, and analytics from one clear performance view.',
    landing_hero_explore_features: 'Explore features',
    landing_hero_watch_demo: 'Watch demo',
    landing_hero_queue_eyebrow: 'Queue & Match Control',
    landing_hero_queue_title: 'Run queue flow, court assignment, and match handling from one live surface.',
    landing_hero_queue_desc: 'Keep sessions moving with court assignment modes, live queue visibility, balanced rotations, and clean match completion workflows.',
    landing_hero_compare_packages: 'Compare packages',
    landing_hero_contact_us: 'Contact us',
    landing_hero_go_to_slide: 'Go to slide',
    landing_hero_prev_slide: 'Previous slide',
    landing_hero_next_slide: 'Next slide',
    landing_hero_pause: 'Pause slideshow',
    landing_hero_play: 'Play slideshow',
    landing_features_badge: 'Core Features',
    landing_features_title: 'Everything your club needs',
    landing_features_desc: 'Built specifically for racket sports clubs - from member management to match analytics.',
    landing_feature_members_title: 'Member Management',
    landing_feature_members_text: 'Bring every player, coach, and admin into one organized member system with smooth onboarding, clear access control, and a structure that scales with your club.',
    landing_feature_members_bullet_1: 'Single and bulk member onboarding',
    landing_feature_members_bullet_2: 'Role and access management',
    landing_feature_members_bullet_3: 'First-time login invitation flow',
    landing_feature_queue_title: 'Queue & Court Flow',
    landing_feature_queue_text: 'Run queue movement and court assignment from one live control surface built for busy sessions, balanced rotations, and smooth match operations.',
    landing_feature_queue_bullet_1: 'Live queue visibility',
    landing_feature_queue_bullet_2: 'Multiple court assignment modes',
    landing_feature_queue_bullet_3: 'Match finishing and automatic queue updates',
    landing_feature_stats_title: 'Stats & Insights',
    landing_feature_stats_text: 'Turn club activity into clear performance visibility with match history, leaderboard movement, reporting, evaluations, and AI-provided insights your team can act on.',
    landing_feature_stats_bullet_1: 'Leaderboard tracking and match history',
    landing_feature_stats_bullet_2: 'Daily reporting and weekly insights',
    landing_feature_stats_bullet_3: 'Evaluation and performance analytics',
    landing_benefits_badge: 'Why Choose Us',
    landing_benefits_title: 'Built for modern racket sports clubs',
    landing_benefits_desc: 'A focused operating system for clubs that need structure, speed, and better control across members, courts, matches, and reporting.',
    landing_benefit_1_title: 'Built for Live Club Sessions',
    landing_benefit_1_text: 'Keep members, queue flow, court assignment, and match handling moving without operational lag.',
    landing_benefit_2_title: 'Structured for Real Club Work',
    landing_benefit_2_text: 'Built around the way real clubs operate, with tools that support daily coordination instead of generic admin overhead.',
    landing_benefit_3_title: 'Ready for Daily Operations',
    landing_benefit_3_text: 'Support onboarding, match control, reporting, and performance review from one dependable system.',
    landing_showcase_badge: 'Showcase',
    landing_showcase_title: 'See Smashlytics in action',
    landing_showcase_desc: 'Watch how our platform transforms club management with intuitive workflows.',
    landing_showcase_1_title: 'Club Setup & Management',
    landing_showcase_1_text: 'Create a club, update core club details, configure courts, schedules, and keep operational settings aligned from day one.',
    landing_showcase_2_title: 'Member Management',
    landing_showcase_2_text: 'Add members one by one or in bulk, manage roles, update member profiles, and keep your club roster organized at scale.',
    landing_showcase_3_title: 'Queue, Courts & Matches',
    landing_showcase_3_text: 'Run live queue flow, assign courts, balance sessions, and finish matches with a clear match-control workflow.',
    landing_showcase_4_title: 'Evaluations',
    landing_showcase_4_text: 'Add and update player evaluations, track rating categories, and keep coaching feedback structured and reviewable.',
    landing_showcase_5_title: 'Match History & Daily Reports',
    landing_showcase_5_text: 'Review completed matches, day-by-day match summaries, and reporting views that help clubs understand session activity clearly.',
    landing_showcase_6_title: 'Profile Management',
    landing_showcase_6_text: 'Update personal profile details, account preferences, and member-facing information from one clean profile workflow.',
    landing_showcase_7_title: 'Equipment Management',
    landing_showcase_7_text: 'Manage club equipment, keep gear records organized, and attach equipment usage while completing matches.',
    landing_showcase_8_title: 'Theme, Branding & Language',
    landing_showcase_8_text: 'Customize club appearance, manage theme settings, and switch platform language to match the way your club operates.',
    landing_open_walkthrough: 'Open walkthrough',
    landing_watch_demo: 'Watch demo',
    landing_pricing_badge: 'Pricing',
    landing_pricing_title: 'Choose your package',
    landing_pricing_desc: "Select the plan that fits your club's needs and scale as you grow.",
    landing_pricing_most_popular: 'Most Popular',
    landing_pricing_save_yearly: 'Save {{pct}}% on yearly billing',
    landing_pricing_choose_plan: 'Choose {{name}}',
    landing_pricing_starter_desc: 'For clubs that need a clean operational base.',
    landing_pricing_pro_desc: 'For established clubs that want deeper performance visibility.',
    landing_pricing_elite_desc: 'For clubs that want advanced control, branding, and AI tooling.',
    landing_pkg_feature_ml_advanced: 'Advanced ML-assisted analytics for key performance trends',
    landing_cta_title: 'Give your club one system for members, courts, matches, and insight.',
    landing_cta_desc: 'Launch with a cleaner operational setup, reduce admin friction, and give players, coaches, and club staff a more professional experience from day one.',
    landing_cta_button: 'Create Your Club',
    landing_contact_badge: 'Contact Us',
    landing_contact_title: 'Talk to us about the right setup for your club.',
    landing_contact_desc: 'Whether you are launching a new venue, replacing scattered admin work, or tightening operations across members, courts, reporting, and analytics, we can help you choose the right package and rollout approach.',
    landing_contact_best_fit_title: 'Best fit',
    landing_contact_best_fit_desc: 'Clubs that want a more structured operating system across member management, queue control, live court assignment, reporting, evaluations, and insight.',
    landing_contact_discuss_title: 'What you can discuss',
    landing_contact_discuss_1: 'Package guidance across Starter, Pro, and Elite',
    landing_contact_discuss_2: 'Member migration, onboarding flow, and access structure',
    landing_contact_discuss_3: 'Operational setup for courts, queue rules, reporting, and coaching workflows',
    landing_footer_subtitle: 'Racket Sports Intelligence System',
    landing_footer_desc: 'Smashlytics brings member operations, court flow, reporting, and performance visibility into one clear system built for modern racket sports organizations.',
    landing_footer_platform: 'Platform',
    landing_footer_access: 'Access',
    landing_footer_signup: 'Signup',
    landing_footer_talk: 'Talk to us',
    landing_footer_note: 'For clubs planning a cleaner operating model.',
    landing_footer_copyright: '© {{year}} Smashlytics. Built for modern racket sports organizations.',
  } as const;

export default en;
